import React from 'react'
import { useState } from 'react';
import {Link} from 'gatsby'

import { graphql, useStaticQuery } from "gatsby"
import { Bar, Radar } from 'react-chartjs-2'

import { getBaseChartBarLine } from './ChartUtils'
import CmpFilterList from "./CmpFilterList"

const RptAnualXIngresoTransportePer = (props) => {
  const [filter, setFilter] =  useState(null);//useState({key: 'Puebla', label: 'Tiendas y Ocio'});
  const [chartType, setChartType] =  useState('bar');  
  const [filters, setFilters] = useState({'filter2': [], 'filter3': [], 'filter4': []})
  const [filterData, setFilterData] = useState(null)
  
  function onFiltersLoaded(loadedFilters, e){
    setFilters(loadedFilters)
  }

  function onFilterSelected(vfilter, e){
    setFilter(vfilter);
  }

  function applyDataFilter(filterName, value){
    setFilterData({filterName: filterName, value: value})
  }  

  return(
    
    <div className="row">  
      {/* <div className="col-lg-3">
        <CmpFilterList value={filter} filters={filterList} onChangeValue={onFilterSelected}></CmpFilterList>
      </div> */}
      <div className="col-lg-12">
        <div className="rpt-chart-types">
            {/* <a className="default-btn small" href="#/" onClick={(e) => {setChartType('radar'); e.preventDefault();} }><i className="flaticon-view"></i>Radar</a> */}
            <a className="default-btn small" href="#/" onClick={(e) => {setChartType('bar'); e.preventDefault();} }><i className="flaticon-view"></i>Bar</a>
            {/* <a className="default-btn small" href="#/" onClick={(e) => {setChartType('stacked'); e.preventDefault();} }><i className="flaticon-view"></i>Stacked</a> */}
            <a className="default-btn small" href="#/" onClick={(e) => {setChartType('line'); e.preventDefault();} }><i className="flaticon-view"></i>Line</a>
        </div>        
        <TheChart value="" filter={filter} chartType={`${chartType}`} onFiltersLoaded={onFiltersLoaded} filterData={filterData}/>
      </div>

      <div className="col-lg-12">
      <div className="widget-area small row" style={{'margin-top': '1.5em'}}>          
            <div className="widget widget_tag_cloud col-lg-4">

                <h3 className="widget-title">Región geográfica</h3>                
                <div className="tagcloud">
                  <Link to="#" onClick={(e) => {applyDataFilter('filter2', null); e.preventDefault();} }> Todos </Link>                

                  {filters['filter2'].map((item) => {
                  return <Link to="#" onClick={(e) => {applyDataFilter('filter2', item); e.preventDefault();} }> {item} </Link>
                  })}
                </div>
            </div>

            <div className="widget widget_tag_cloud col-lg-4">
                <h3 className="widget-title">Ciudad turística de playa</h3>                
                <div className="tagcloud">
                  <Link to="#" onClick={(e) => {applyDataFilter('filter3', null); e.preventDefault();} }> Todos </Link>

                  {filters['filter3'].map((item) => {
                  return <Link to="#" onClick={(e) => {applyDataFilter('filter3', item); e.preventDefault();} }> {item} </Link>
                  })}
                </div>                
            </div>

            <div className="widget widget_tag_cloud col-lg-4">
                <h3 className="widget-title">Grandes ciudades</h3>                
                <div className="tagcloud">
                  <Link to="#" onClick={(e) => {applyDataFilter('filter4', null); e.preventDefault();} }> Todos </Link>

                  {filters['filter4'].map((item) => {
                  return <Link to="#" onClick={(e) => {applyDataFilter('filter4', item); e.preventDefault();} }> {item} </Link>
                  })}
                </div>                
            </div>

      </div>        
      </div>

    </div>    

  )

}


export default RptAnualXIngresoTransportePer


// ====================== The chart

export const query = graphql`

fragment metadataAnualIngresoTransporte on BdanualCsv {
  label: Entidad    
  filter: Entidad
  filter2: Region_Geografica
  filter3: Ciudades_Turisticas_de_Playa
  filter4: Grandes_Ciudades
}

{
  bd: allBdanualCsv(sort: {fields: Entidad}) {

    Quintil_1: nodes{
      data: Porcentaje_de_Gasto_de_los_Hogares_que_Utilizan_Transporte__Q1
      ...metadataAnualIngresoTransporte
    }
    Quintil_2: nodes{
      data: Porcentaje_de_Gasto_de_los_Hogares_que_Utilizan_Transporte__Q2
      ...metadataAnualIngresoTransporte
    }
    Quintil_3: nodes{
      data: Porcentaje_de_Gasto_de_los_Hogares_que_Utilizan_Transporte__Q3
      ...metadataAnualIngresoTransporte
    }
    Quintil_4: nodes{
      data: Porcentaje_de_Gasto_de_los_Hogares_que_Utilizan_Transporte__Q4
      ...metadataAnualIngresoTransporte
    }
    Quintil_5: nodes{
      data: Porcentaje_de_Gasto_de_los_Hogares_que_Utilizan_Transporte__Q5
      ...metadataAnualIngresoTransporte
    }    


    }


    filters: allBdanualCsv(
      sort: {fields: Region_Geografica}
    ) {        
        filter2: distinct(field: Region_Geografica)
        filter3: distinct(field: Ciudades_Turisticas_de_Playa)
        filter4: distinct(field: Grandes_Ciudades)
    }

}
`

const TheChart = (props) => {
    const data = useStaticQuery(query)
    const { filters: filters} = data

    props.onFiltersLoaded(filters) // notify loaded filters    
    
    let fill = props.chartType == 'radar' ? true : false
    let chart = getBaseChartBarLine(data, props.filter ? props.filter : props.filterData ? props.filterData : null, props.chartType, false, fill)


    return(
        <div className="rpt-chart">            
            <h4>{chart.title}</h4>

            { props.chartType == 'radar' && <Radar data={chart.data} options={{ legend: {position: 'top'} 
              ,scale: { ticks: {  callback: function(value, index, values) { return Math.floor(value*100) + ' %';}   }  }

              ,tooltips: {                
                callbacks: {
                    title: (tooltipItem, data) => data.labels[tooltipItem[0].index], 
                    label: function(tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label || '';
                        if (label) {label += ': ';}
                        label += (tooltipItem.yLabel*100).toFixed(2) + ' %' 
                        return label;
                    }
                }
              }

            }}/> }            

            { props.chartType == 'stacked' && <Bar data={chart.data} options={{ legend: {position: 'top'} ,scales: { xAxes: [{stacked: true}],yAxes: [{stacked: true}]}}}/> }

            { props.chartType != 'radar' && <Bar data={chart.data} options={{ legend: {position: 'top'} 
              ,scales: { yAxes: [ {ticks: { beginAtZero: true, callback: function(value, index, values) { return Math.floor(value*100) + ' %';}   } } ] }

              ,tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label || '';
                        if (label) {label += ': ';}
                        label += (tooltipItem.yLabel*100).toFixed(2) + ' %' 
                        return label;
                    }
                }
              }

            }}/> }            

        </div>
    )
}

